import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const ContainerRecaptcha = styled.div<{ theme: ThemeType }>`
  width: 100%;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .texto {
    text-align: left;
    padding: 3rem 0;
    color: ${(props) => props.theme.colors.tertiary};
    width: 100%;
  }

  .box {
    padding: 2rem 0 4rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    .input {
      width: 100%;
    }
  }
`;
